import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/NewPost.css';
import { ApiContext } from '../context/ApiContext';
import NewPostButton from './NewPostButton';
import apiCall from '../utils/apiCall';
import useAuthState from '../hooks/useAuthState';
import { useDemo } from '../context/DemoContext';

const NewPost = () => {
    const navigate = useNavigate();
    const apiUrl = useContext(ApiContext);
    const [postContent, setPostContent] = useState('');
    const [isModalOpen, setIsModalOpen] = useState(false);
    const { isAuthenticated } = useAuthState();
    const { isDemoMode, addPost: demoAddPost } = useDemo();

    const handleInput = (e) => {
        setPostContent(e.target.value);
        e.target.style.height = '50px'; // Reset height
        e.target.style.height = `${e.target.scrollHeight}px`; // Adjust height
    };

    const handlePost = async () => {
        const postData = {
            content: postContent,
        };

        if (isDemoMode) {
            demoAddPost(postContent);
            setPostContent('');
            setIsModalOpen(false);
            return;
        }

        try {
            const postUrl = apiUrl ? `${apiUrl}/api/v1/post/` : '/api/v1/post/';
            const response = await apiCall(postUrl, 'POST', postData, {
                'X-Client-Type': 'web'
            });

            if (response.ok) {
                setPostContent('');
                document.querySelector('.new-post-textarea').style.height = '50px';
                navigate(0); // Refresh the page
                document.querySelector('.new-post-textarea').focus();
                setIsModalOpen(false); // Close modal after posting
            } else {
                console.error('Failed to submit post');
            }
        } catch (error) {
            console.error('Error while submitting post:', error);
        }
    };

    return (
        <>
            {isAuthenticated && (
                <NewPostButton onClick={() => setIsModalOpen(true)} />
            )}

            {isModalOpen && (
                <div className="modal-overlay">
                    <div className="modal-content">
                        <textarea
                            placeholder="What's on your mind?"
                            value={postContent}
                            onChange={handleInput}
                            className="new-post-textarea"
                        />
                        <div className="modal-action-buttons">
                            <button className="close-button" onClick={() => setIsModalOpen(false)}>
                                Cancel
                            </button>
                            <button
                                onClick={handlePost}
                                disabled={!postContent.trim()}
                                className="new-post-button"
                            >
                                Post
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default NewPost;
